import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import {Card, CardBody, Form} from 'reactstrap';
import {reportingApi} from '../../../api';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import FileInput from '../../../shared/FileInput';
import {IPicture} from '../../../shared/interfaces/Picture';
import ReportingFileTable from './ReportingFileTable';

export interface IReportingFiles {
  report: File[];
  campaign?: string;
}

const ReportingForm = () => {
  const {id} = useParams();
  const {t} = useTranslation();
  const methods = useForm<IReportingFiles>();
  const [fileList, setFileList] = useState<IPicture[]>([]);

  const onFormSubmit = async (state: IReportingFiles) => {
    const formData = new FormData();
    for (const item of state.report) {
      formData.append('report', item);
    }
    formData.append('campaign', `${id}`);
    const {data} = await reportingApi.uploadReportingFile(formData, id ?? '');
    if (data) {
      methods.reset();
      getReportings(id ?? '');
    }
  };

  const getReportings = async (campaignId: string) => {
    const {
      data: {reports: data},
    } = await reportingApi.getAllReportings(campaignId);
    setFileList(data);
  };

  useEffect(() => {
    if (!!id) {
      getReportings(id);
    }
  }, [id]);
  return (
    <div className="row my-3">
      <div className="col-12">
        <Card className="card-bordered card-preview mt-2">
          <CardBody>
            <FormProvider {...methods}>
              <Form onSubmit={methods.handleSubmit(onFormSubmit)} className="py-3">
                <FileInput
                  accept=".pdf,.msword,.png,.jpeg,.gif,.webm,.quicktime,.mp4,.zip,.msvideo,.avi,.vnd.rar,.x-zip-compressed, .x-matroska',"
                  isMultiple={false}
                  name="report"
                  label="File Upload"
                />

                {!!methods.watch('report') && (
                  <div className="d-flex justify-content-end ">
                    <Button color="primary">
                      <Icon name="plus-sm" />
                      {t('general.upload')}
                    </Button>
                  </div>
                )}
              </Form>
            </FormProvider>
            <div className=" mt-3">
              {!!fileList?.length ? (
                <ReportingFileTable showDelete fileList={fileList} setFileList={setFileList} />
              ) : (
                <div className="my-5 text-center">No reporting yet.</div>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ReportingForm;
